// src/utils/clearCorruptedStorage.ts
import logger from '../lib/logger';

/**
 * Utility to clear corrupted storage data that contains [object Object]
 * This can be called when the app detects storage corruption
 */
export function clearCorruptedStorage() {
  logger.log('🔍 Checking for corrupted storage data...');

  // Check sessionStorage
  const sessionKeys = Object.keys(sessionStorage);
  sessionKeys.forEach((key) => {
    const value = sessionStorage.getItem(key);
    if (value === '[object Object]' || (value && value.includes('"[object Object]"'))) {
      console.error(`🔍 Found corrupted sessionStorage key: ${key}, clearing...`);
      sessionStorage.removeItem(key);
    }
  });

  // Check localStorage
  const localKeys = Object.keys(localStorage);
  localKeys.forEach((key) => {
    const value = localStorage.getItem(key);
    if (value === '[object Object]' || (value && value.includes('"[object Object]"'))) {
      console.error(`🔍 Found corrupted localStorage key: ${key}, clearing...`);
      localStorage.removeItem(key);
    }
  });

  logger.log('🔍 Storage cleanup complete');
}

// Run on app initialization
export function initStorageCleanup() {
  // Clear corrupted data on startup
  clearCorruptedStorage();

  // Also add a global error handler to catch these issues
  window.addEventListener('error', (event) => {
    if (event.message && event.message.includes('[object Object]" is not valid JSON')) {
      console.error('🔍 Detected storage corruption error, cleaning up...');
      clearCorruptedStorage();
      // Reload the page to reinitialize with clean storage
      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
  });
}
